import { render, staticRenderFns } from "./ChildSupportCalculations.vue?vue&type=template&id=477c59dc"
import script from "./ChildSupportCalculations.vue?vue&type=script&lang=js"
export * from "./ChildSupportCalculations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports